export default [
  {
    path: '/wt/bankDirectDetail',
    name: '银企直联相关',
    component: () => import ( /* webpackChunkName: "serveTable" */ `@/views/bankDirect/bankDirect.vue`),
  },
];
